//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import JobDetails from './_components/JobDetails';
import LineDialog from '~/components/Dialog/LineDialog';
import { isEmpty } from 'lodash';
import { replaceSpecialCharacters } from '~/utils';
const axios = require('axios');

export default {
  name: 'JobsContent',
  components: { JobDetails, LineDialog },
  data() {
    return {
      applyShow: false,
      jobDetail: {},
      isFavorite: false,
    };
  },
  watch: {
    userCategory() {
      // 職缺頁面做登入
      if (this.token && this.userCategory === 0) {
        // 若網址帶有推薦碼
        const query = this.$route.query;
        if (Object.keys(query).length > 0) {
          if (query.code) sessionStorage.setItem('refer_code', query.code);
        }
        const referCode = sessionStorage.getItem('refer_code') || query.code;
        const id = this.$route.query.id || 0;

        // 一般會員登入時 增加瀏覽紀錄 並加上推薦碼
        this.addUserBrowseHistory(id);
        if (referCode) this.addShareJob(id, referCode);
      }
    },
  },
  computed: {
    ...mapGetters('jsonld', ['jsonldObj']),
    ...mapGetters('jobs', ['currentJobId']),
    ...mapGetters('user', ['token', 'userName', 'userCategory']),
    ...mapGetters('personal', ['basicData']),
    liffUrl() {
      const id = this.$route.query.id || 0;
      const code = this.$route.query.code;
      return `${process.env.LINE_LIFF_URL}?action=job&jobId=${id}`;
    },
  },
  methods: {
    ...mapActions('jobs', ['setCurrentJobId', 'setCurrentCompanyId']),
    addShareJob(id, code) {
      if (!code) return;
      const payload = {
        jobPositionId: id,
        referCode: code,
      };
      this.$api('accessShareJob', payload);
    },
    openApply() {
      this.applyShow = true;
    },
    addUserBrowseHistory(id) {
      this.$api('addUserBrowseHistory', { jobPositionId: id });
    },
  },
  mounted() {
    if (process.client) {
      const query = this.$route.query;
      const id = this.$route.query.id || 0;
      this.setCurrentJobId(id);

      // 若網址帶有推薦碼
      if (Object.keys(query).length > 0) {
        if (query.code) sessionStorage.setItem('refer_code', query.code);
      }
      const referCode = sessionStorage.getItem('refer_code') || query.code;

      // 一般會員登入時 增加瀏覽紀錄 並加上推薦碼
      if (this.token && this.userCategory === 0) {
        this.addUserBrowseHistory(id);
        if (referCode) this.addShareJob(id, referCode);
      }
    }
  },
  head() {
    return {
      title: `${this.ogTitle}`,
      meta: [
        {
          hid: 'url',
          property: 'url',
          content: `${this.url}`,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.url}`,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.ogTitle}`,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `${this.ogDescription}`,
        },
        {
          hid: 'description',
          name: 'description',
          content: `${this.ogDescription}`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.ogTitle}`,
        },
      ],
      link: [{ rel: 'canonical', href: this.url }],
      script: [
        {
          hid: this.jobHid,
          type: 'application/ld+json',
          json: this.jsonldScript,
        },
      ],
    };
  },
  async asyncData({ route, payload }) {
    let jsonldScript = {};
    try {
      jsonldScript = require(`@/static/jsonld_id/${route.params.id}.json`);
    } catch (e) {
      console.log('script jsonldScript not found');
    }

    let data = '',
      jobDetail = '',
      ownerName = '',
      isFavorite = false,
      ogTitle = '',
      ogDescription = '',
      pageTitle = '',
      pageJobCatName = '',
      pageJobContent = '',
      jobHid = '',
      url = '';

    //SEO
    const lifecycle = process.env.npm_lifecycle_event;
    if (['generate', 'generate:dev'].includes(lifecycle)) {
      data = payload;
    } else {
      const apiURL = `${process.env.domainUrl}/apis/job-position/${route.query.id}`;

      try {
        const result = await axios.get(apiURL);
        data = result.data.data;
      } catch (e) {
        console.log('_id asyncData apiURL not found');
      }
    }

    if (!isEmpty(data)) {
      const detailData = data;
      jobDetail = detailData;
      ownerName = detailData.ownerName;
      isFavorite = detailData.isFavorites;
      pageTitle = detailData.title;
      pageJobCatName = detailData.jobCatName;
      pageJobContent = detailData.content;
      jobHid = detailData.id;
    }
    ogTitle = `${replaceSpecialCharacters(pageTitle)} - ${ownerName} | STEP1NE`;
    ogDescription = `${pageTitle} - ${pageJobCatName} | ${pageJobContent}`;
    url = `${
      process.env.domainUrl
    }/JobsContent/${jobHid}-${replaceSpecialCharacters(pageTitle)}`;

    return {
      jsonldScript,
      jobHid,
      url,
      ogTitle,
      ogDescription,
      jobDetail,
      isFavorite,
    };
  },
  // jsonld() {
  //   try {
  //     const jsonldFile = require(`@/static/jsonld_id/${this.$route.params.id}.json`);
  //     console.log('jsonldFile:', jsonldFile);

  //     return jsonldFile;
  //   } catch (e) {
  //     console.log('jsonldFile not found');
  //     return null;
  //   }
  // },
};
